import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22index.tsx%22,%22import%22:%22Source_Serif_4%22,%22arguments%22:[{%22subsets%22:[%22greek%22,%22latin%22],%22variable%22:%22--font-source-serif%22,%22display%22:%22swap%22}],%22variableName%22:%22sourceSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Source Serif 4', 'Source Serif 4 Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
